import React, { useRef, useEffect, useState } from 'react';
import styles from './GrowthChartSection.module.scss';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Legend, Tooltip } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Legend, Tooltip);

const chartData = [
  { year: 2025, value: 22, properties: 24 },
  { year: 2026, value: 72, properties: 76 },
  { year: 2027, value: 172, properties: 190 },
  { year: 2028, value: 375, properties: 388 },
  { year: 2029, value: 792, properties: 804 },
];

const data = {
  labels: chartData.map(d => d.year),
  datasets: [
    {
      label: 'Total Enterprise Value $M',
      data: chartData.map(d => d.value),
      backgroundColor: '#3489DB',
      borderRadius: 6,
      barPercentage: 0.5,
    },
    {
      label: 'Total Properties',
      data: chartData.map(d => d.properties),
      backgroundColor: '#80C9BA',
      borderRadius: 6,
      barPercentage: 0.5,
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: { color: '#fff', font: { family: 'Urbanist', size: 14 } },
    },
    tooltip: {
      enabled: true,
    },
  },
  scales: {
    x: {
      grid: { color: '#333' },
      ticks: { color: '#fff', font: { family: 'Urbanist', size: 13 } },
    },
    y: {
      grid: { color: '#333' },
      ticks: { color: '#fff', font: { family: 'Urbanist', size: 13 } },
      beginAtZero: true,
    },
  },
  animation: {
    duration: 2000,
    delay: (context) => {
      // Delay increases for each data point, creating sequential animation
      return context.dataIndex * 300;
    },
  },
};

const GrowthChartSection = () => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100 && !visible) {
        setVisible(true);
        // Force chart re-render to trigger animation
        setKey(prev => prev + 1);
      }
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [visible]);

  return (
    <section id="growth" ref={ref} className={styles.section}>
      <div className={styles.card + ' ' + (visible ? styles.visible : '')}>
        <h2 className={styles.title}>Projected Growth</h2>
        {visible && <Bar key={key} data={data} options={options} />}
        {!visible && <Bar data={data} options={{...options, animation: {duration: 0}}} />}
      </div>
    </section>
  );
};

export default GrowthChartSection;
